var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.832031 15.0213C0.832031 7.55846 6.7962 0.833374 15.027 0.833374C23.0737 0.833374 29.1654 7.43077 29.1654 14.9788C29.1654 23.7327 22.0254 29.1667 14.9987 29.1667C12.6754 29.1667 10.097 28.5424 8.0287 27.3223C7.3062 26.8825 6.69703 26.5561 5.91786 26.8115L3.0562 27.6628C2.3337 27.8898 1.68203 27.3223 1.89453 26.5561L2.8437 23.378C2.99953 22.9382 2.9712 22.47 2.74453 22.1011C1.5262 19.8594 0.832031 17.4049 0.832031 15.0213ZM13.157 15.0213C13.157 16.0287 13.9645 16.8374 14.9704 16.8516C15.9762 16.8516 16.7837 16.0287 16.7837 15.0355C16.7837 14.0282 15.9762 13.2195 14.9704 13.2195C13.9787 13.2053 13.157 14.0282 13.157 15.0213ZM19.6879 15.0355C19.6879 16.0287 20.4954 16.8516 21.5012 16.8516C22.507 16.8516 23.3145 16.0287 23.3145 15.0355C23.3145 14.0282 22.507 13.2195 21.5012 13.2195C20.4954 13.2195 19.6879 14.0282 19.6879 15.0355ZM8.43953 16.8516C7.44786 16.8516 6.6262 16.0287 6.6262 15.0355C6.6262 14.0282 7.4337 13.2195 8.43953 13.2195C9.44536 13.2195 10.2529 14.0282 10.2529 15.0355C10.2529 16.0287 9.44536 16.8374 8.43953 16.8516Z",
    fill: "#1792C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.7b9fed7a982089466bc76ce889273c7e.svg";
export { ForwardRef as ReactComponent };